import React, { useState, useEffect } from "react";
import EndedTab from "../NavTabs/EndedTab";
import { useParams } from "react-router-dom";
import ClaimCard from "./ClaimCard";
import { _IDOSaleContractData } from "../../Services/Web3Connection";

export default function ClaimList(props) {
  const { status } = useParams();
  const [ClaimCounter, setClaimCounter] = useState(0);

  // useEffect(async () => {
  //   let idoSale = await _IDOSaleContractData(status);
  //   // console.log(idoSale.Contract.methods);
  //   // ClaimDetails(idoSale.Contract);
  //   let ddata = idoSale.Contract.methods.ClaimCounter().call();
  //   setClaimCounter(ddata);
  // }, []);

  // function ClaimDetails(Contract) {
  //   Contract.methods
  //     .ClaimCounter()
  //     .call()
  //     .then((res) => {
  //       console.log(res, "calaim round");
  //       setClaimCounter(res);
  //     });
  // }
  return (
    <>
      {/* {console.log(ClaimCounter)} */}
      <EndedTab />
    </>
  );
}
